import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useSearchParams } from "wouter";
import { Button } from "catalyst/button";
import { Heading } from "catalyst/heading";
import { Text } from "catalyst/text";
import { urlApiProfile } from "../lib/api.js";
import { recoverExpiredSession } from "../lib/session.js";
import { ApiError, bumpEpoch, postJson } from "../lib/util.js";
export const AppLoginSuccess = () => (_jsxs("div", { className: "max-w-lg space-y-6", children: [_jsx(Heading, { children: "\u0412\u0445\u043E\u0434 \u0432 CoreInfra Wizard \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D" }), _jsx(Text, { children: "\u0412\u0435\u0440\u043D\u0438\u0442\u0435\u0441\u044C \u0432 Wizard. \u042D\u0442\u0443 \u0432\u043A\u043B\u0430\u0434\u043A\u0443 \u043C\u043E\u0436\u043D\u043E \u0437\u0430\u043A\u0440\u044B\u0442\u044C." })] }));
/** Wizard login approval. The server is the only validator of the loopback callback. */
const AppLogin = () => {
    const [params] = useSearchParams();
    const callbackUrl = params.get("callback_url") ?? "";
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const approve = async () => {
        setSubmitting(true);
        setError(null);
        try {
            const { redirect_url } = await postJson("/hub/api/app-login", { callback_url: callbackUrl });
            window.location.replace(redirect_url);
        }
        catch (err) {
            if (recoverExpiredSession(err, urlApiProfile))
                return bumpEpoch();
            setError(err instanceof ApiError && err.status === 400
                ? "Некорректный адрес Wizard. Начните вход заново из Wizard."
                : "Не удалось войти в Wizard. Попробуйте ещё раз.");
            setSubmitting(false);
        }
    };
    return (_jsxs("div", { className: "max-w-lg space-y-6", children: [_jsx(Heading, { children: "\u0412\u0445\u043E\u0434 \u0432 CoreInfra Wizard" }), _jsx(Text, { children: "Wizard \u0437\u0430\u043F\u0440\u0430\u0448\u0438\u0432\u0430\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0443." }), error && _jsx(Text, { role: "alert", children: error }), _jsx("div", { className: "flex flex-wrap gap-3", children: _jsx(Button, { color: "light", type: "button", disabled: submitting, onClick: () => void approve(), children: "\u0412\u043E\u0439\u0442\u0438" }) })] }));
};
export default AppLogin;
